module.exports = __webpack_public_path__ + "static/media/titletransp.5406dc1a.jpg";